import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import styles from './ViewDocSection.module.less';
import unityLogo from 'assets/img/unity-engine-logo.jpg';
import unrealLogo from 'assets/img/unreal-engine-logo.jpg';

export default function ViewDocSection() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.ViewDocSectionBackground}>
				<div className={styles.ViewDocSectionContainer}>
					<div className={styles.ViewDocSectionImgFlex}>
						<img
							src={unityLogo}
							alt="Unity Engine Logo"
							className={styles.ViewDocSectionImg}
						/>
						<img
							src={unrealLogo}
							alt="Unreal Engine Logo"
							className={styles.ViewDocSectionImg}
						/>
					</div>
					<div className={styles.ViewDocSectionText}>
						Game engines are essential to the development process. Whether you
						use Unity or Unreal, we’ve ensured that you have the right tools,
						samples, best practices, and technical documentation at hand to
						develop your Omni One games.
					</div>
				</div>
			</div>
		</>
	);
}
